import { useMemo } from "react";
import { concatQueryStrings } from "views/logic/queries/QueryHelper";
const concatQuery = (queryParts) => concatQueryStrings(queryParts.filter((queryPart) => !!queryPart));
const useLocalStorageConfigData = ({ mappedData, checked }) => useMemo(() => {
  const {
    queryWithReplacedParams,
    searchFilterQuery,
    searchFromValue,
    columnValuePath,
    rowValuePath,
    lutParameters,
    searchWithinMs,
    streams,
    aggValue,
    aggFunction,
    aggField,
    columnGroupBy,
    rowGroupBy
  } = mappedData;
  const queries = Object.entries({
    queryWithReplacedParams,
    searchFilterQuery,
    searchFromValue,
    columnValuePath,
    rowValuePath
  }).filter(([key]) => checked[key]).map(([_, search]) => search);
  const getAggregations = () => {
    const res = {};
    if (checked.aggCondition) {
      res.agg_field = aggField;
      res.agg_value = aggValue;
      res.agg_function = aggFunction;
    }
    if (checked.columnGroupBy) {
      res.group_by = columnGroupBy;
    }
    if (checked.rowGroupBy) {
      res.group_by = (rowGroupBy || []).concat(res.group_by || []);
    }
    return res;
  };
  const getRest = () => {
    const res = {};
    if (checked.lutParameters && lutParameters && lutParameters.length) res.loc_query_parameters = lutParameters;
    if (checked.searchWithinMs && searchWithinMs) res.search_within_ms = searchWithinMs;
    if (checked.streams && streams && streams.length) res.streams = streams;
    return res;
  };
  return {
    type: "aggregation-v1",
    query: concatQuery(queries),
    ...getAggregations(),
    ...getRest()
  };
}, [checked, mappedData]);
export default useLocalStorageConfigData;
